import { render, staticRenderFns } from "./SharePopup.vue?vue&type=template&id=2e78c135&scoped=true&"
import script from "./SharePopup.vue?vue&type=script&lang=js&"
export * from "./SharePopup.vue?vue&type=script&lang=js&"
import style0 from "./SharePopup.vue?vue&type=style&index=0&id=2e78c135&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78c135",
  null
  
)

export default component.exports